import { IAppConfig, PasswordValidationConditions } from './config.interface';

const setPasswordValidationDefaults = (config: IAppConfig): IAppConfig => {
    if (!config.signup.passwordValidationConditions?.DEFAULT) {
        config.signup.passwordValidationConditions = {
            DEFAULT: [
                PasswordValidationConditions.LOWERCASE,
                PasswordValidationConditions.MINMAXLENGTH,
                PasswordValidationConditions.NUMBER,
                PasswordValidationConditions.SYMBOL,
                PasswordValidationConditions.UPPERCASE,
            ],
        };
    }

    return config;
};

export const setDefaults = (config: IAppConfig) => {
    const defaultsHandlers = [setPasswordValidationDefaults];

    const result = defaultsHandlers.reduce((config, handler) => {
        return handler(config);
    }, config);

    return result;
};
